import { Field, RadioGroup } from '../../../../Core';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { pipe } from 'Lib/Hooks/Selectors';
import { ExcludedMaterial } from 'Components/Worksheets/Core/Fields';

let PreparationSectionBase = ({ createWorksheetSelector }: IWorksheetComponent): JSX.Element => {
  const airDryingUsed = useSelector(pipe(createWorksheetSelector!('Preparation.Method'), (m) => m === 'B'));

  return (
    <ListFieldSection>
      <FieldSet>
        <Field
          input={<RadioGroup />}
          label="Method"
          name="Preparation.Method"
          options={[
            { value: 'A', label: 'A - General classification' },
            { value: 'B', label: 'B - Fuel use' },
          ]}
          confirm={airDryingUsed}
          confirmTitle="Confirm Preparation Method Change"
          confirmText="Any existing data for the air drying step will be removed."
          confirmButtonText="Change Preparation Method"
        />
      </FieldSet>
      <ExcludedMaterial editable descriptionAlwaysVisible appendNamePrefix="Preparation" />
    </ListFieldSection>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);
export { PreparationSection };
export default PreparationSection;
